import { get } from "svelte/store";
import type { PersistedAddress } from "../api/address";
import { continueWorkflow, activateWorkflow } from "../apiLoader/campaign";
import { getCampaignUser } from "../helpers/campaignUserManager";
import { updateSession } from "../stores/session";
import { selectedAddressStore } from "../../lib/stores/addresses";
import { getCurrentProcess } from "../utils";

export const activateAndContinueWorkflow = async () => {
  const selectedAddress = get(selectedAddressStore) as PersistedAddress;
  await activateWorkflow(selectedAddress?.id);
  const campaignUser = await getCampaignUser();

  updateSession({
    lastUserStatusUpdate: campaignUser.current_status_updated_at
  });

  const processKey = getCurrentProcess(campaignUser.metadata);
  await continueWorkflow(processKey);
};
